export default __webpack_public_path__ + "static/media/19.c26561ff.jpg";